import { TextField } from "@material-ui/core";
import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import Message from "../message";

function DnbScraper() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [row_offset, setRow_offset] = useState(0);
  const [companies, setCompanies] = useState("");
  const [status_companies, setStatus_companies] = useState("");

  const sumbit_companies = async () => {
    setStatus_companies("");

    if (companies.length <= 0) {
      setStatus_companies("Upload csv input!");
    } else if (row_offset === "") {
      setStatus_companies("Fill row_offset name!");
    } else {
      const companies_formData = new FormData();
      companies_formData.set("file", companies);

      const requestOptions = {
        method: "POST",
        body: companies_formData,
      };

      try {
        const companies_response = await fetch(
          apiServer +
            `api/dnb_scraper/upload_file?row_offset=${row_offset}`,
          requestOptions
        );
        const companies_status_id = await companies_response.json();
        const companies_status = companies_status_id.detail ? companies_status_id.detail : companies_status_id;
        setStatus_companies(companies_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
        <p>Row offset is like telling the scraper where to begin reading information from input file</p>
      <TextField
        style={{ marginBottom: "15px", width: "100%" }}
        value={row_offset}
        onChange={(e) => setRow_offset(e.target.value)}
        id="outlined-basic"
        label="Row offset"
        variant="filled"
      />
      <Form.Control
        type="file"
        onChange={(e) => setCompanies(e.target.files[0])}
      />
      <Button
        style={{
          marginBottom: "15px",
          width: "100%",
          backgroundColor: "#3a4c7a",
          border: "none",
        }}
        href="./templates/dnb_scraper_template.csv"
        download
      >
        Download Template
      </Button>
      <Button
        variant="primary"
        style={{ marginTop: "20px", width: "100%" }}
        onClick={() => sumbit_companies()}
      >
        Submit
      </Button>
      {Message(status_companies, setStatus_companies)}
    </div>
  );
}

export default DnbScraper;
